import { removeZeroWidthWhiteSpaceAndTrim } from '@app/libs/inputFormat';

/**
 * 키워드 선정 논의 스레드
 * https://modusign.slack.com/archives/C04TDPXPXE3/p1678875586335449
 */
export const sensitiveDocumentTitleKeywords = ['연봉', '근로', '스톡옵션', '주식매수선택권'];

/**
 * 민감 키워드 존재 여부를 검사하기위해 공백을 제거하고 영문은 소문자로 변환합니다.
 * @param value
 */
function parseForValidation(value: string): string {
  return removeZeroWidthWhiteSpaceAndTrim(value).toLowerCase().replace(/ /g, '');
}

/**
 * 문서 제목에 민감한 키워드가 있는지 검사합니다.
 * @param title
 */
export default function getSensitiveDocumentTitleKeywords(title: string): string[] {
  const parsedTitle = parseForValidation(title);
  return sensitiveDocumentTitleKeywords
    .map((keyword) => (parsedTitle.includes(parseForValidation(keyword)) ? keyword : ''))
    .filter((keyword) => !!keyword);
}
